import { useEffect } from 'react';
import { X } from 'lucide-react';
import { useUiStore, type Toast } from '@/stores/ui';
import { cx } from '@/lib/format';

function ToastItem({ t }: { t: Toast }) {
  const dismiss = useUiStore((s) => s.dismissToast);
  useEffect(() => {
    const id = setTimeout(() => dismiss(t.id), t.durationMs ?? 5000);
    return () => clearTimeout(id);
  }, [t, dismiss]);
  const tone = { info: 'border-info', success: 'border-ok', warning: 'border-warn', error: 'border-danger' }[t.kind];
  return (
    <div role="status" className={cx('pointer-events-auto flex w-80 items-start gap-2 rounded-lg border-l-4 border border-line bg-bg-elev p-3 text-sm shadow-lg', tone)}>
      <div className="flex-1">
        <div className="font-medium">{t.title}</div>
        {t.body && <div className="mt-0.5 text-xs text-fg-muted">{t.body}</div>}
        {t.action && (
          <button type="button" className="mt-1 text-xs font-medium text-accent" onClick={() => { t.action?.onClick(); dismiss(t.id); }}>
            {t.action.label}
          </button>
        )}
      </div>
      <button type="button" aria-label="Dismiss" className="text-fg-subtle hover:text-fg" onClick={() => dismiss(t.id)}>
        <X size={14} />
      </button>
    </div>
  );
}

export function Toaster() {
  const toasts = useUiStore((s) => s.toasts);
  return (
    // top-right: the bottom edge belongs to the dock (selection toolbar + upload tray)
    <div className="pointer-events-none fixed top-14 right-4 z-[200] flex flex-col gap-2" aria-live="polite">
      {toasts.map((t) => (
        <ToastItem key={t.id} t={t} />
      ))}
    </div>
  );
}
